import { Injectable, signal } from '@angular/core';

export type MobileMode = 'desktop' | 'chat';

const MOBILE_BREAKPOINT = 768;

@Injectable({ providedIn: 'root' })
export class MobileModeService {
  readonly isMobile = signal(false);
  readonly showModeSelector = signal(false);
  readonly selectedMode = signal<MobileMode | null>(null);

  constructor() {
    this.checkMobile();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => this.checkMobile());
    }
  }

  private checkMobile(): void {
    if (typeof window === 'undefined') {
      return;
    }
    this.isMobile.set(window.innerWidth <= MOBILE_BREAKPOINT);
  }

  checkAndShowSelector(): void {
    this.checkMobile();
    if (!this.isMobile()) {
      this.showModeSelector.set(false);
      return;
    }
    this.showModeSelector.set(true);
  }

  selectMode(mode: MobileMode): void {
    this.selectedMode.set(mode);
    this.showModeSelector.set(false);
  }
}
